<template>
    <rkm-modal
        :loading="loading"
        hide-footer
        ref="RkmModal"
        title="Selecione o local"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col
                    v-for="sala in salas"
                    v-bind:key="sala.id"
                >
                    <rkm-button
                        @click="store(sala.id)"
                        block
                        class="big-button"
                        color="primary"
                    >
                        {{ sala.nome }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
    },
    created() {
        this.repositories = {
            chamada: this.getConectaSusRepository('painelSenha.chamada')
        }
    },
    data: () => ({
        filaId: null,
        telaId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(filaId, telaId) {
            this.filaId = filaId
            this.telaId = telaId

            this.$refs.RkmModal.show()
        },
        store(salaId) {
            const request = {
                filaId: this.filaId,
                telaId: this.telaId,
                salaId: salaId,
            }

            this.setLoading()

            this.repositories.chamada.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => this.close())
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        salas: {type: Array, required: true},
    },
}
</script>